/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, min, max, on_sale) {
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(min);
    var res = '';
    var salePricing = false;
    if(typeof on_sale !== 'undefined'){
      salePricing = true
    }
    if (comparing || salePricing) {
      if(min !== max){
        res = '<b class="ais-hit--price-discount">' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';

      } else {
        res += '<b class="ais-hit--price-discount ais-hit--price-sale">' + formatPrice(price) + '</b>';
        res += ' <span class="ais-hit--price-striked">' + formatPrice(compare_at_price) +'</span> ';
        var saleAmount = Number(compare_at_price) - Number(price);
        res += '<span class="ais-hit--price-savings">Save '+ formatPrice(saleAmount) +'</span>';
      }
    } else {
      if(min !== max){
        res = '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
      } else {
        res = '<b>' + formatPrice(price) + '</b>';
      }
    }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(text,render) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    instantsearchPrice: function instantsearchPrice() {
      var min = this.variants_min_price;
      var max = this.variants_max_price;
      return formattedPriceWithComparison(this.price, this.compare_at_price, min, max);
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return ('/products/' + this.handle + (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' (' + this.variant_title + ')';
      }
      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    truncatedHTMLTitle: function truncatedHTMLTitle() {
      var origRes = new DOMParser().parseFromString(this._highlightResult.title.value,'text/html').documentElement.textContent;
      var res = origRes.split(" ").splice(0, 6).join(" ");
      if (res.length < origRes.length) {
        res += "...";
      }
      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLTitle: function fullHTMLTitle() {
      var res = new DOMParser().parseFromString(this._highlightResult.title.value,'text/html').documentElement.textContent;
      if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLVendor: function fullHTMLVendor() {
      if(typeof this._highlightResult.vendor !== 'undefined'){
        var res = new DOMParser().parseFromString(this._highlightResult.vendor.value,'text/html').documentElement.textContent;
        return res;
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    saleBadge: function() {
      let badgeHtml = "";
      let badgeType = false;
      let badgeClass = "";

      if (this.named_tags['badge']) {
        if (this.named_tags['badge'] == ':sale') {
          badgeType = "Special Deal";
          badgeClass = "sale";
        } else if (this.named_tags['badge'] == ':best-seller') {
          badgeType = "Bestseller";
          badgeClass = "bestseller";
        } else if (this.named_tags['badge'] == ':new') {
          badgeType = "New";
          badgeClass = "new";
        }
      }

      if(badgeType) {
        badgeHtml = '<span class="ais-hit--sale-badge ' + badgeClass + '">' + badgeType + '</span>';
      }

      return badgeHtml;
    }
  };

  ['pico','icon','thumb','small','compact','medium','large','grande','original',].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];
    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);